module.exports = __webpack_public_path__ + "static/media/first.3b2f8ea5.png";